//
//
//
//
//
//

import dayjs from "dayjs";
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      options: {},
    };
  },
  computed: {
    categoryData() {
      if (this.list.length > 0) {
        return this.list[0].data.map((v) =>
          dayjs(v.timestamp).format("YY年M月")
        );
      }
    },
  },
  watch: {
    list() {
      this.renderChart();
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const props = {
        type: "line",
        symbol: "none",
        smooth: true,
        lineStyle: {
          width: 3,
        },
      };
      const regFenToYuan = this.regFenToYuan;
      let series = this.list.map((v) => ({
        ...props,
        name: v.name,
        data: v.data.map((v) => regFenToYuan(v.Value)),
      }));
      this.options = {
        color: ["#FFC793", "#FFEBCA", "#F8BDD6", "#93C6FF"],
        tooltip: {
          show: true,
          trigger: "axis",
        },
        legend: {
          top: "2%",
        },
        grid: {
          left: "5%",
          top: "15%",
          bottom: "20%",
          right: "16%",
        },
        xAxis: {
          type: "category",
          data: this.categoryData,
          axisLine: {
            lineStyle: {
              color: "#844D1A",
              opacity: 0.5,
            },
          },
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: "#844D1A",
            },
          },
          axisLabel: {
            color: "#333333",
            showMaxLabel: true,
          },
        },
        yAxis: {
          type: "value",
          position: "right",
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#844D1A",
              opacity: 0.1,
              shadowOffsetX: 500,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#333333",
          },
        },
        series,
      };
    },
  },
};
